import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import DeleteCitationsCommand from './deletecitationscommand';

export default class CitationUI extends Plugin {
  init() {
    const editor = this.editor;
    editor.commands.add( 'deletecitations', new DeleteCitationsCommand( editor ) );
  }
}
